import { Navigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { Sparkles } from 'lucide-react';

interface RequireBusinessProps {
  children: React.ReactNode;
}

export function RequireBusiness({ children }: RequireBusinessProps) {
  const { user, authLoading, business, businessLoading } = useApp();

  // Show loading while checking auth or business
  if (authLoading || businessLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <div className="w-12 h-12 mx-auto rounded-full bg-primary/20 flex items-center justify-center animate-pulse-soft">
            <Sparkles className="w-6 h-6 text-primary" />
          </div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to landing page if not authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Redirect to onboarding if no business exists
  if (!business) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
